import { CheckCircle, Clock } from "lucide-react";

export const cancelledSteps = [
  {
    id: "initiated",
    label: "Refund Initiated",
    icon: <Clock className="w-5 h-5" />,
    completed: false,
    current: false,
  },
  {
    id: "Processed",
    label: "Refund Approved",
    icon: <CheckCircle className="w-5 h-5" />,
    completed: false,
    current: false,
  },
];

export const refund_initiated_msg_string = `Delivery canceled due to operational reasons –
refund initiated`;

export const refund_initiated_string = "Refund initiated";

export const lm_status_track = {
  "SHIPMENT DESTROYED / DISPOSED": refund_initiated_string,
  damage: refund_initiated_string,
  damaged: refund_initiated_string,
  "SHIPMENT DESTROYED / DISPOSED": refund_initiated_string,
  "Shipment Under Investigation": refund_initiated_string,
};

export const lm_status_message = {
  "SHIPMENT DESTROYED / DISPOSED": refund_initiated_msg_string,
  damage: refund_initiated_msg_string,
  damaged: refund_initiated_msg_string,
  "SHIPMENT DESTROYED / DISPOSED": refund_initiated_msg_string,
  "Shipment Under Investigation": refund_initiated_msg_string,
  "Mis Route": "Delivery delayed",
  undelivered_due_to_rejection_by_customer: "Delivery Attempted",
  "delivery delayed": "Delivery delayed",
  "Received At Delivery Centre": "Received At Delivery Centre",
  undelivered_due_to_request_for_reschedule:
    "Delivery rescheduled on customer request",
  "Not Delivered": "Undelivered",
  delivered: "Delivered",
  "OTP Based Delivered": "Delivered",
  rto_completed: "RTO Completed",
  "in transit": "In Transit",
  "Shipped complete": "Dispatched",
  confirmed: "Confirmed",
};
